import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';
import { BrowserFrame, Chip, DemoCaption } from '../compass/shared';

// Section 11 — Resource Library, two-column with the genuine screenshot.
export const ForeseeResources = ({ sp }) => (
  <section aria-labelledby="foresee-resources-heading" data-testid="foresee-resources" className="bg-mist py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid items-center gap-14 lg:grid-cols-2">
        <Reveal className="order-last lg:order-first">
          <BrowserFrame shot={sp.shots.resources} label="Foresee — demonstration workspace" />
          <DemoCaption />
        </Reveal>
        <Reveal delay={0.12}>
          <SectionHeader
            align="left"
            eyebrow="Controlled Information"
            title="Give teams access to the right resources"
            description={sp.resourcesCopy}
            testid="foresee-resources-header"
          />
          <div className="mt-6 flex flex-wrap gap-2" data-testid="foresee-resource-types">
            {(sp.resourceTypes || []).map((t) => <Chip key={t}>{t}</Chip>)}
          </div>
          <p className="mt-6 border-l-2 border-indigo-500 pl-4 text-sm font-medium leading-relaxed text-slate-600">
            Site or group-level access can be configured so people see the resources relevant to where they work.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
